<template>
  <div>
    <search-agents-profile-product @submit="submitSearch" />

    <div class="simiot-table-operation-buttons">
      <a-space>
        <a-button
          type="primary"
          @click="showImportModal"
          v-if="isShowMenu('agents_profile_products/import')"
        >导入Profile</a-button>

        <update-agents-profile-product-effective
          v-if="isShowMenu('agents_profile_products/effective')"
          :selected-row-keys="selectedRowKeys"
          @completed="fetchData"
        />
      </a-space>
    </div>

    <a-table
      size="middle"
      :scroll="{ x: 'max-content' }"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      row-key="id"
    >
      <span slot="actions" slot-scope="text, record">
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            操作 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-if="isHasEditPermission">
              <a @click="showEditModal(record.id)">编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a @click="showOperationHistoryModal(record.id)">操作历史</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

    <import-agents-profile-product
      v-if="isShowImportModal"
      :agent-id="agentId"
      :visible.sync="isShowImportModal"
      @completed="fetchData"
    />

    <edit-agents-profile-product
      v-if="isShowEditModal"
      :visible.sync="isShowEditModal"
      :id="editingId"
      @completed="fetchData"
    />

    <operation-history-list-modal
      v-if="isShowOperationHistoryModal"
      :reference-id="showingOperationHistoryId"
      reference-type="AgentsProfileProduct"
      :visible.sync="isShowOperationHistoryModal"
    />
  </div>
</template>

<script>
import { hasPermission } from '@/utils/permission'
import { findAgentsProfileProducts } from '@/api/agents_profile_product'
import { formatFloat } from '@/utils/filter'
import Pagination from '@/components/Pagination'
import SearchAgentsProfileProduct from '@/views/agents_profile_products/Search'

export default {
  name: 'AgentsProfileProductList',
  components: {
    Pagination,
    SearchAgentsProfileProduct,
    ImportAgentsProfileProduct: () => import('@/views/agents_profile_products/import/index'),
    EditAgentsProfileProduct: () => import('@/views/agents_profile_products/Edit'),
    UpdateAgentsProfileProductEffective: () => import('@/views/agents_profile_products/UpdateEffective'),
    OperationHistoryListModal: () => import('@/views/operation_histories/Modal')
  },
  data() {
    return {
      data: [],
      columns: [
        {
          title: '产品名称',
          dataIndex: 'name',
          width: 180
        },
        {
          title: '标准价(元)',
          dataIndex: 'price',
          width: 120,
          customRender: formatFloat
        },
        {
          title: '底价(元)',
          dataIndex: 'floor_price',
          width: 120,
          customRender: formatFloat
        },
        {
          title: '有效性',
          dataIndex: 'effective',
          width: 100
        },
        {
          title: '创建时间',
          dataIndex: 'created_at',
          width: 170
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      loading: true,
      selectedRowKeys: [],
      isShowImportModal: false,
      isShowEditModal: false,
      isShowOperationHistoryModal: false,
      showingOperationHistoryId: 0,
      editingId: 0,
      pagination: {
        total_count: 0
      },
      query: { effective: '1' }
    }
  },
  computed: {
    agentId() {
      return parseInt(this.$route.params.id)
    },
    isHasEditPermission() {
      return hasPermission('agents_profile_products/edit')
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    isShowMenu(menu) {
      return hasPermission(menu)
    },

    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    showImportModal() {
      this.isShowImportModal = true
    },

    showEditModal(id) {
      this.editingId = id
      this.isShowEditModal = true
    },

    showOperationHistoryModal(id) {
      this.showingOperationHistoryId = id
      this.isShowOperationHistoryModal = true
    },

    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.selectedRowKeys = []
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findAgentsProfileProducts(Object.assign({ agent_id: this.agentId }, this.query)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
